/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         25/04/24 - 23:39:22
 * Module name:  mkad-groups.service
 * File name:    mkad-groups.service.ts
 * IDE:          WebStorm
 */


import {Injectable} from '@angular/core';
import {MkadBaseService, URLS_SERVICE} from '@shared/services';
import {map, Observable} from 'rxjs';
import {HttpResponse} from '@angular/common/http';
import {HTTP_CODE_SUCCESS} from '@shared/constants';
import {
  GroupFormInterface,
  GroupListInterface,
  GroupsSummaryListInterface,
  MkadGroupParamInterface,
} from '@shared/interface';

@Injectable({
  providedIn: 'root'
})
export class MkadGroupService extends MkadBaseService {
  private readonly customer = URLS_SERVICE.meerkad.customer;
  private readonly groups = URLS_SERVICE.meerkad.group;

  summary(param?: MkadGroupParamInterface): Observable<GroupsSummaryListInterface[]> {
    return this.http.post<GroupsSummaryListInterface[]>(this.customer.base + this.groups.base + this.groups.summary, param);
  }

  list(): Observable<GroupListInterface[]> {
    return this.http.post<GroupListInterface[]>(this.customer.base + this.groups.base + this.groups.list);
  }

  get(groupId: number): Observable<GroupFormInterface> {
    return this.http.post<GroupFormInterface>(this.customer.base + this.groups.base + this.groups.get, {id: groupId});
  }

  create(toCreate: GroupFormInterface): Observable<GroupFormInterface> {
    return this.http.post<GroupFormInterface>(this.customer.base + this.groups.base + this.groups.create, toCreate);
  }

  delete(groupId: number): Observable<boolean> {
    return this.http.post<HttpResponse<boolean>>(this.customer.base + this.groups.base + this.groups.delete, {id: groupId}).pipe(
      map((prevResponse) => {
          if (!prevResponse) return true;
          return prevResponse.status === HTTP_CODE_SUCCESS;
        },
      ));
  }

  update(toUpdate: GroupFormInterface): Observable<GroupFormInterface> {
    return this.http.post<GroupFormInterface>(this.customer.base + this.groups.base + this.groups.update, toUpdate);
  }

}
